import axios from 'axios';
import { url } from '../api/env';

const axiosInstance = axios.create({
  baseURL: url,
});

axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from session storage
    const token = sessionStorage.getItem('token');
    // If token exists, add it to the headers
    if (token) {
      config.headers['userid'] = sessionStorage.getItem('uid');
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
